import { useEffect, useState, useRef } from "react";
export function useIsInViewportWithInitialState(elem, triggers = [], options) {
    const [isInViewport, setIsInViewport] = useState();
    const observerRef = useRef();
    useEffect(() => {
        observerRef.current = new IntersectionObserver(([entry]) => setIsInViewport(entry.isIntersecting), options);
    }, [options]);
    useEffect(() => {
        if (!elem)
            return;
        if (!observerRef.current)
            return;
        const targetElem = elem instanceof HTMLElement ? elem : elem.current;
        if (!targetElem)
            return;
        observerRef.current.observe(targetElem);
        return () => {
            observerRef.current?.disconnect();
        };
    }, [elem, ...triggers]);
    return isInViewport;
}
export default function useIsInViewport(elem, triggers = [], options) {
    return Boolean(useIsInViewportWithInitialState(elem, triggers, options));
}
